<template>
    <BreadCrumb PageTitle="Liste des types de cargaison" />
    <ListeTypeCargaison/>
  </template>
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTypeCargaison from "@/components/TypeCargaison/ListeTypeCargaison.vue";
  
    export default defineComponent({
      name: "ListeTypeCargisonPage",
      components: {
        BreadCrumb,
        ListeTypeCargaison,
      },
    });
  </script>